import { defineComponent } from 'vue';
export default defineComponent({
    name: 'DataTable',
    props: {
        loading: Boolean,
        data: Object
    },
    setup() {
        const headers = [
            { text: 'Seq', value: 'coSeq', sortable: false },
            { text: 'Company Name', value: 'companyName', sortable: false },
            { text: 'Company Id', value: 'companyId', sortable: false },
            { text: 'Api Key', value: 'companyApiKey', sortable: false },
            { text: 'RegistedBy', value: 'registBy', sortable: false },
            { text: 'RegistedDate', value: 'registDate', sortable: false }
        ];
        return {
            headers
        };
    }
});
